
import { ref, defineComponent } from "vue";
import { fetchList } from "./helper";
import { RouterName } from "@/router";
import { useRouter } from "vue-router";
import { getTitle } from "@/utils/util";
import { store } from "@/store";

export default defineComponent({
  name: "SendToMe",
  setup() {
    const postdata = {
      state: "",
      type: "4",
      page: 0,
      pagesize: 10,
      approval_temp_ids: ""
    };
    const filterBtn = [
      {
        value: "0",
        text: "全部"
      },
      {
        value: "1",
        text: "审批中"
      },
      {
        value: "2",
        text: "审批通过"
      },
      {
        value: "3",
        text: "审批未通过"
      }
    ];
    const router = useRouter();
    const { state, onLoad } = fetchList();
    const active = ref("0");
    const stores_common = ref(store.state.shopConfig?.stores_common || "2");
    const checked = ref(false);
    // 加载页面数据
    const goOnLoad = () => {
      postdata.page++;
      onLoad(postdata.state, postdata.type, postdata.page, postdata.pagesize, {
        approval_temp_ids: postdata.approval_temp_ids,
        start_user_ids: checked.value ? store.state.userInfo?.id : ""
      });
    };
    // 切换table
    const toggleActive = (activeName: string) => {
      if (postdata.state === activeName) return;
      active.value = activeName;
      postdata.state = activeName;
      postdata.page = 0;
      postdata.page++;
      onLoad(postdata.state, postdata.type, postdata.page, postdata.pagesize);
    };
    // 刷新列表
    const afreshList = () => {
      postdata.page = 0;
      postdata.page++;
      onLoad(postdata.state, postdata.type, postdata.page, postdata.pagesize, {
        approval_temp_ids: postdata.approval_temp_ids,
        start_user_ids: checked.value ? store.state.userInfo?.id : ""
      });
    };
    // 去详情
    const toDetail = (id: string) => {
      router.push({
        name: RouterName.APPROVAL_DETAIL,
        params: {
          id
        }
      });
    };
    const statusClass = (type: any) => {
      if (type) {
        const obj: any = {
          1: "blue-status",
          2: "grey-status",
          3: "orange-status"
        };
        return obj[type];
      }
      return "";
    };
    return {
      postdata,
      state,
      onLoad,
      active,
      filterBtn,
      toggleActive,
      toDetail,
      goOnLoad,
      getTitle,
      checked,
      afreshList,
      stores_common,
      statusClass
    };
  }
});
